/**
 * 未来平台埋点
 * 平台：https://tlog.talbrain.com/
 * API 文档：https://npm.100tal.com/#/detial?name=%40peiyou%2Fxesanalytics
 * 产品文档：https://wiki.zhiyinlou.com/pages/viewpage.action?pageId=170956725
 * 获取项目公参接口：https://wiki.zhiyinlou.com/pages/viewpage.action?pageId=174666712
 */

import XesAnalytics from '@peiyou/xesanalytics/dist';
import UAParser from 'ua-parser-js';
import store from '@/store';

const xesAnalytics = new XesAnalytics({
  event_env: process.env.NODE_ENV === 'production' ? 'prod' : 'test', // 数据上报环境，prod=生产环境，test=测试环境
  proj_id: '013_00203', // 项目id，必传，集团未来埋点平台申请 [小猴编程: 013_00203]
  show_log: ['development', 'test'].includes(process.env.NODE_ENV), // 是否开启日志打印，默认关闭
  auto_track: false, // 是否开启全埋点，默认关闭
  collect_tags: {}, // 是否开启其他任意元素的全埋点采集（默认不采集），详见全埋点说明模块
  source: '8', // 来源，必传，取值逻辑参考(1=android手机端/2=ios手机端/3=app内嵌h5/4=小程序内嵌h5/5=微信app内游离h5(非小程序)/6=服务器后端/7=QQapp内游离h5/8=Web端/9=ipad端/10=安卓pad/11=小程序原生/12=授课端/13=新辅导端/14=老辅导端/100=其它)
  saas: false, // 是否埋点上传地址是saas部署的域名，传true为saas上传的域名地址，不传或者传false为培优埋点地址,默认值为false
});

/**
 * 去除对象中，值为 undefined、null、空字符串 的 key
 * @param {*} obj 要检查的对象
 * @returns 去除值为 undefined、null 的 key 后的对象
 */
const removeNull = (obj = {}) => Object.entries(obj).reduce((total, [key, value]) => {
  if (![undefined, null, ''].includes(value)) {
    // eslint-disable-next-line no-param-reassign
    total[key] = value;
  }
  return total;
}, {});

/** 设置用户信息相关的用户参数和公共业务参数 */
export function xesInitUser() {
  const profile = {
    user_id: '', // 用户ID, 请求登录接口返回的 id || 如果学生登录返回的是：stu_id || 如果是教师登录返回的是empNo
    user_name: '', // 用户名称
    user_role: '', // 角色 '0'老师 ‘1’ 学生
  };
  xesAnalytics.setProfile(profile); // 重置用户信息
  const pub = {
    user_state: '0', // '0' 未登录，'1' 已登陆
    terminal: new UAParser().getBrowser().name // 来源
  };

  const userInfo = JSON.parse(localStorage.getItem(store.getters.tokenKey) || '{}');
  const { id, username } = userInfo;

  if (!id) {
    // 未登录
    profile.user_state = '0';
    pub.user_state = '0';
  } else {
    pub.user_state = '1';
    profile.user_state = '1';
    profile.user_id = id;
    profile.user_name = username;
    profile.user_role = '1';
  }

  xesAnalytics.setProfile(removeNull(profile));
  xesAnalytics.registerPage(pub);
}
xesInitUser();
// 手动登录/退出登录，需要重新设置用户信息和公共参数
const signSetItem = localStorage.setItem
localStorage.setItem = function(key) {
  signSetItem.apply(this, arguments)

  if (key === store.getters.tokenKey) {
    xesInitUser()
  }
}

/**
 * 生成编辑器相关公参
 * @param {obj} params 题组对象
 * @param {number} index 当前编辑器在题组中的下标
 */
 const categoryMap = new Map([
  [1, 'CodeMonkey'],
  [2, 'Scratch'],
  [3, 'Python'],
  [4, 'C++'],
  [5, '选择题'],
  [6, 'Paper'],
  [7, 'MakeBlock'],
  [8, 'Python'],
  [9, 'C++'],
  [11, '视频题']
])
export function generateEditorPub(category) {
  const pub = {}
  switch (category) {
    case 1:
      pub.language = categoryMap.get(1)
      pub.editor = categoryMap.get(1)
      break
    case 2:
      pub.language = categoryMap.get(2)
      pub.editor = 'Scratch编辑器'
      break
    case 3:
    case 8:
      pub.language = categoryMap.get(3)
      pub.editor = 'Python编辑器'
      break
    case 4:
    case 9:
      pub.language = categoryMap.get(4)
      pub.editor = 'C++编辑器'
      break
    default:
      pub.language = '通用'
      pub.editor = categoryMap.get(category)
      break
  }
  return pub
}


/**
 * 新增或改变业务公共参数
 * @param {{[key: string]: any}} publicData 新增或改变的项目公参
 */
export function setXESPublic(publicData = {}) {
  xesAnalytics.registerPage(removeNull(publicData));
}

/**
 * 上报点击类型的埋点，适用于 script 中使用
 * @param {string} id 事件ID, 必填
 * @param {object} obj 自定义业务属性，非必填，仅支持一层json结构，不支持多层嵌套
 * @param {function} cb 回调方法，非必填，埋点数据存入队列后执行
 */
export function xesClick(id, obj, cb) {
  xesAnalytics.track(id, obj, cb);
}

/**
 * 上报浏览类型的埋点， 适用于 script 中使用
 * @param {string} id 事件ID, 必填
 * @param {object} obj 自定义业务属性，非必填，仅支持一层json结构，不支持多层嵌套
 * @param {function} cb 回调方法，非必填，埋点数据存入队列后执行
 */
export function xesView(id, obj, cb) {
  xesAnalytics.view(id, obj, cb);
}

// 自定义指令，适用于直接在模板中使用
const weakmap = new WeakMap();
export default {
  install(Vue) {
    /**
     * 点击时，触发 track 方法
     * 1.无业务参数使用示例：v-xes-analytics-track:id
     * 2.有业务参数使用示例：v-xes-analytics-track:id="{ name: 'xxx' }"
     */
    Vue.directive('xes-analytics-track', {
      inserted(el, { value, arg }) {
        const cache = () => xesAnalytics.track(arg, value);
        weakmap.set(el, cache);
        el.addEventListener('click', cache);
      },
      unbind(el) {
        if (weakmap.get(el)) {
          el.removeEventListener('click', weakmap.get(el));
        }
      },
    });

    /**
     * dom inserted 时，触发 view 方法
     * 1.无业务参数使用示例：v-xes-analytics-view:id
     * 2.有业务参数使用示例：v-xes-analytics-view:id="{ name: 'xxx' }"
     */
    Vue.directive('xes-analytics-view', {
      inserted(el, { value, arg }) {
        xesAnalytics.view(arg, value);
      },
    });
  },
};
